exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.messagebar{position:absolute;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;width:calc(100% - 10px);padding:5px;border-radius:3px;border-bottom:4px solid #cf2a27;background-color:#cf2a27;height:2rem}.messagebar p{margin:0;padding:0;font-size:1rem;text-align:center;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/messagebar/styles.scss
// module id = 1030
// module chunks = 0